import { useContext } from "react";

import type { ChromeVisibilityContextValue } from "../../context/sectionTabs/chromeTypes";
import { ChromeVisibilityContext } from "../../context/sectionTabs/ChromeVisibilityContext";

const noop = () => {};

/**
 * No-op fallback when consumed outside a MobileSectionTabsProvider - see
 * `useMobileTabsOverride`'s doc comment for why this exists.
 */
const FALLBACK_CONTEXT: ChromeVisibilityContextValue = {
  isAvatarHidden: false,
  setIsAvatarHidden: noop,
  isChromeHidden: false,
  setIsChromeHidden: noop,
  isBottomNavHidden: false,
  setIsBottomNavHidden: noop,
  isTopNavHidden: false,
  setIsTopNavHidden: noop,
  isFullBleedContent: false,
  setIsFullBleedContent: noop,
  isFixedHeightContent: false,
  setIsFixedHeightContent: noop,
  isHideChromeOnScrollDisabled: false,
  setIsHideChromeOnScrollDisabled: noop,
  isTopBarUnbranded: false,
  setIsTopBarUnbranded: noop,
};

/**
 * Register/read the mobile shell's ref-counted chrome-visibility/layout
 * flags (`isAvatarHidden`, `isChromeHidden`, `isBottomNavHidden`,
 * `isTopNavHidden`, `isFullBleedContent`, `isFixedHeightContent`,
 * `isHideChromeOnScrollDisabled`, `isTopBarUnbranded`).
 */
export const useMobileChromeVisibility = () => {
  const context = useContext(ChromeVisibilityContext);
  if (!context && process.env.NODE_ENV === "development") {
    console.warn(
      "useMobileChromeVisibility: called outside MobileSectionTabsProvider, using noop fallback. " +
        "This is expected for pages on the legacy app shell path.",
    );
  }
  return context ?? FALLBACK_CONTEXT;
};
